import React from "react";
import { Container } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../assets/css/student/solutions/SolutionsTittle.css';

const SolutionsTittle = () => {
  return (
    <section className="sol-title">

      {/* ── Top Banner ── */}
      <div className="sol-title__banner">
        <Container>
          <div className="sol-title__banner-inner">

            <h1 className="sol-title__heading">
              <span className="sol-title__heading--highlight">
                This is what we do
              </span>
            </h1>

            <p className="sol-title__text">
              We strive to make education accessible to all, supporting students
              with fees, uniforms, and books so every child can reach their full
              potential
            </p>

          </div>
        </Container>
      </div>

    </section>
  );
};

export default SolutionsTittle;